// facebook.test.js
import Facebook from "@/pixels/providers/facebook";
import Vue from "vue";

describe("Facebook", () => {
  beforeEach(() => {
    window.fbq = jest.fn();
    jest.spyOn(Facebook, "enable");

    document.createElement = jest.fn(() => ({
      addEventListener: jest.fn()
    }));
    document.getElementsByTagName = jest.fn(() => [
      {
        appendChild: jest.fn(),
        parentNode: {
          insertBefore: jest.fn()
        }
      }
    ]);
    Vue.$log = {
      info: jest.fn()
    };
  });

  it("configuracion por defecto para Enable", () => {
    Facebook.enable();
    const enableMock = jest.spyOn(Facebook, "enable");
    expect(enableMock).toHaveBeenCalledTimes(1);
  });

  it("calls fbq with correct parameters on init", () => {
    Facebook.init();
    expect(window.fbq).toHaveBeenCalledWith("init", "1649877658563488");
  });

  it("calls fbq with correct parameters on paso1", () => {
    Facebook.paso1();
    expect(window.fbq).toHaveBeenCalledWith("trackCustom", "Ver contenido", {
      content_type: "Nominas_jubilados"
    });
  });

  it("calls fbq with correct parameters on thank", () => {
    Facebook.gracias();
    expect(window.fbq).toHaveBeenCalledWith("trackCustom", "Comprar", {
      content_type: "Nominas_jubilados"
    });
  });

  it("0", () => {
    const context = {
      mutation: {
        payload: {
          params: {
            mje: 0
          }
        }
      }
    };

    Facebook.mensaje(context);
    expect(window.fbq).toHaveBeenCalledWith("track", "PageView", {
      content_type: "Nominas_jubilados"
    });
  });

  it("msj 1", () => {
    const context = {
      mutation: {
        payload: {
          params: {
            mje: 1
          }
        }
      }
    };

    Facebook.mensaje(context);
    expect(window.fbq).toHaveBeenCalledWith("trackCustom", "Completar registro", {
      content_type: "Nominas_jubilados"
    });
  });
});